/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, AnyAction } from '@reduxjs/toolkit';

import type { Errors, Failure } from 'state/shared/types';

export type CountryCode = {
  code: number;
  country: string;
};

export type CountryCodes = CountryCode[];

export type SliceState = {
  countryCodes: CountryCodes;
  pending: boolean;
  errors: Errors;
};

export const initialState: SliceState = {
  countryCodes: [],
  pending: false,
  errors: [],
};

const countryCodesSlice = createSlice({
  name: 'countryCodes',
  initialState,
  reducers: {
    COUNTRY_CODES_REQUEST(_state, _action: AnyAction) {},
    COUNTRY_CODES_SUCCESS(state, action: PayloadAction<CountryCodes>) {
      state.errors = [];
      state.countryCodes = action.payload;
    },
    COUNTRY_CODES_FAILURE(state, action: PayloadAction<Failure>) {
      state.errors.push(action.payload);
    },
  },
});

export const countryCodesActions = countryCodesSlice.actions;

export default countryCodesSlice.reducer;
